import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'

import {
	Button,
	Icon,
	Menu,
	Accordion,
	AccordionSummary,
	MenuItem,
	FormControlLabel,
	AccordionDetails,
	Checkbox
} from '@material-ui/core'

import { ExpandMore } from '@material-ui/icons'

import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'
import { setSelectedGroomingFilters } from '../../../../actions/visits/visits.actions'
import { cloneDeep, isEqual } from 'lodash'

const useStyles = makeStyles((theme) => ({
	headerButton: {
		fontFamily: 'Nunito',
		fontWeight: '700',
		'& .MuiButton-label': {
			lineHeight: '19px',
			fontSize: '14px'
		}
	},
	filterButton: {
		zIndex: 1
	},
	filterIcon: {
		fontSize: 19,
		color: '#777679',
		marginRight: 8
	},
	filterButtonLabel: {
		alignItems: 'center'
	},
	accordianExpanded: {
		margin: '0px !important'
	},
	check: {
		padding: 0,
		marginRight: 16,
		height: 18,
		width: 18,
		color: '#D0CFD2'
	},
	formLabel: {
		marginLeft: 0
	},
	summary: {
		minHeight: 54,
		'&.Mui-expanded': {
			minHeight: 54
		}
	},
	summaryContent: {
		margin: 0,
		'&.Mui-expanded': {
			margin: 0
		}
	},
	accordian: {
		boxShadow: 'none !important',
		'&::before': {
			height: 0
		}
	},
	detailsRoot: {
		flexDirection: 'column',
		backgroundColor: '#F9F9F9',
		padding: '8px 0px'
	},
	labelRoot: {
		paddingTop: 0,
		paddingBottom: 0,
		padding: '0px 16px 0px 56px'
	},
	label: {
		fontSize: '16px',
		fontWeight: 600,
		lineHeight: '22px',
		textTransform: 'capitalize'
	},
	accordianItem: {
		padding: '8px 0px'
	}
}))

export const GroomingFilterButton = (props) => {
	const classes = useStyles()
	const dispatch = useDispatch()
	const [isFilterOpen, setIsFilterOpen] = useState(false)
	const [filterMenuEl, setFilterMenuEl] = useState(null)

	const selectedFilters = useSelector((state) => state.specific.visits.selectedGroomingFilters)
	const filters = useSelector((state) => state.specific.visits.grooming_filters)

	const handleClick = (event) => {
		setFilterMenuEl(event.currentTarget)
		setIsFilterOpen(true)
	}

	return (
		<div>
			<Button
				className={clsx(classes.headerButton, classes.filterButton)}
				onClick={handleClick}
				variant="outlined"
				size="large"
				classes={{
					label: classes.filterButtonLabel
				}}
				aria-controls="filter-menu"
				aria-haspopup="true">
				<Icon className={clsx(classes.filterIcon, 'fas fa-sliders-h')} />
				{Object.keys(selectedFilters).reduce(
					(acc, cur) =>
						Array.isArray(selectedFilters[cur])
							? acc + selectedFilters[cur].length
							: typeof selectedFilters[cur] === 'boolean' && selectedFilters[cur]
							? acc + 1
							: acc + 0,
					0
				)}
			</Button>
			<Menu
				open={isFilterOpen}
				id="filter-menu"
				anchorEl={filterMenuEl}
				getContentAnchorEl={null}
				anchorOrigin={{
					vertical: 30,
					horizontal: -280
				}}
				onClose={() => setIsFilterOpen(false)}
				MenuListProps={{
					style: {
						padding: 0
					}
				}}
				PaperProps={{
					style: {
						width: 339,
						borderRadius: 10,
						maxHeight: 454
					}
				}}>
				{Object.keys(filters).map((f) => {
					let filter = filters[f]

					if (Array.isArray(filter)) {
						let filterOptions = filter.map((o) => o.value)

						let label = f.split('_').join(' ')
						label = label.charAt(0).toUpperCase() + label.slice(1)
						let checked = filter.some((o) => selectedFilters[f].includes(o.value))

						return (
							<Accordion
								classes={{
									root: classes.accordian,
									expanded: classes.accordianExpanded
								}}>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									classes={{
										root: classes.summary,
										content: classes.summaryContent
									}}
									onClick={(e) => e.stopPropagation()}
									key={f}
									aria-label="Expand"
									aria-controls="additional-actions1-content"
									id="additional-actions1-header">
									<FormControlLabel
										style={{
											marginLeft: 0
										}}
										classes={{
											label: classes.label
										}}
										onClick={(e) => e.stopPropagation()}
										control={
											<Checkbox
												className={classes.check}
												checked={checked}
												onChange={(e) => {
													e.stopPropagation()
													let updates = cloneDeep(selectedFilters)

													if (!checked) {
														updates[f] = [
															...new Set([
																...updates[f],
																...filter.map((o) => o.value)
															])
														]
													} else {
														updates[f] = updates[f].filter(
															(o) => filterOptions.findIndex((s) => s === o) === -1
														)
													}

													dispatch(setSelectedGroomingFilters(updates))
												}}
											/>
										}
										label={label}
									/>
								</AccordionSummary>
								<AccordionDetails
									classes={{
										root: classes.detailsRoot
									}}>
									{filter.map((o) => {
										let selected = selectedFilters[f].includes(o.value)
										return (
											<MenuItem
												classes={{
													root: classes.accordianItem
												}}
												key={o.value}>
												<FormControlLabel
													className={classes.formLabel}
													classes={{
														root: classes.labelRoot,
														label: classes.label
													}}
													control={
														<Checkbox
															className={classes.check}
															checked={selected}
															onChange={(e) => {
																e.stopPropagation()
																let updates = cloneDeep(selectedFilters)

																updates[f] = selected
																	? updates[f].filter((s) => s !== o.value)
																	: [...updates[f], o.value]

																dispatch(setSelectedGroomingFilters(updates))
															}}
														/>
													}
													label={o.label}
												/>
											</MenuItem>
										)
									})}
								</AccordionDetails>
							</Accordion>
						)
					} else if (typeof filter === 'object') {
						let selected = selectedFilters[f]

						return (
							<MenuItem className={classes.summary} key={f}>
								<FormControlLabel
									className={classes.formLabel}
									classes={{
										label: classes.label
									}}
									control={
										<Checkbox
											checked={selected}
											className={classes.check}
											onChange={() => {
												let updates = cloneDeep(selectedFilters)

												updates[f] = !updates[f]

												dispatch(setSelectedGroomingFilters(updates))
											}}
										/>
									}
									label={filter.label}
								/>
							</MenuItem>
						)
					} else {
						return null
					}
				})}
			</Menu>
		</div>
	)
}
